import _get from 'lodash/get';

// get some necessary data for owner
const getOwnersProperties = function (owner) {
  if (owner === void 0) {
    owner = {};
  }
  const propertyKeys = ['privateSeller'];
  return Object.fromEntries(Object.entries(owner).filter(_ref => {
    let [key] = _ref;
    return propertyKeys.includes(key);
  }));
};

/**
 * Find inventory and owner data using inventoryId
 */
export default (function (state, inventoryId, isDealer) {
  if (state === void 0) {
    state = {};
  }
  const inventory = _get(state, `inventory.${inventoryId}`) || _get(state, `preorder.${inventoryId}`) || _get(state, 'cbhVehicleInterests.activeResults', []).find(listing => listing.id === inventoryId) || {};
  let owner = {};
  if (_get(inventory, 'owner.id')) {
    // if inventory.owner is already an object
    ({
      owner
    } = inventory);
  } else if (_get(state, `owners.${inventory.owner}`)) {
    // if inventory.owner is owner id
    owner = _get(state, `owners.${inventory.owner}`);
  } else if (isDealer) {
    owner = _get(state, `owners.${inventoryId}`, {});
  } else if (_get(inventory, 'ownerId')) {
    // sometimes the listing only has ownerId -- and owner data would be a separate object
    owner = {
      id: _get(inventory, 'ownerId')
    };
  }
  return {
    ...inventory,
    owner: {
      ...owner,
      ...getOwnersProperties(_get(state, `owners.${inventory.ownerId}`))
    }
  };
});